import { Endpoints, AbuseReportDispatcher } from "Roblox";
import angular from "angular";
import chatModule from '../chatModule';

function dialogController($scope, $log, chatService, chatUtility, messageService,
    dialogAttributes, keyCode, gameService, resources, $filter, messageHelper) {
    "ngInject";
    //// ----------------------------------- PRIVATE --------------------------------

    $scope.removeFromConversation = function (conversationId, layoutId) {
        chatService.removeFromConversation($scope.chatLibrary.userId, conversationId);
        if ($scope.chatLibrary.chatLayoutIds && $scope.chatLibrary.chatLayoutIds.indexOf(layoutId) > -1) {
            $scope.chatLibrary.conversationsDict[conversationId].remove = true;
            $scope.closeDialog({ layoutId: layoutId });
        }
    }

    $scope.sendPerformanceData = function(message) {
        if (Math.random() < $scope.chatLibrary.relativeValueToRecordUiPerformance) {
            var startSendingTime = message.startSendingTime;
            var endRespondingTime = new Date().getTime();
            var interval = endRespondingTime - startSendingTime;
            chatService.sendPerformanceData(resources.performanceMeasurements.messageSend, interval);
        }
    }

    var sendMessage = function(newMessage) {
        chatService.sendMessage($scope.dialogData.id, newMessage.rawContent).then(
            function (data) {
                if (data) {
                    newMessage.sendingMessage = false;
                    newMessage.canResend = false;
                    $scope.sendPerformanceData(newMessage);

                    if (data.resultType !== chatUtility.resultType.SUCCESS) {
                        newMessage.sendMessageHasError = true;
                        newMessage.error = chatUtility.errorMessages.default;

                        if (data.resultType === chatUtility.resultType.MODERATED) {
                            newMessage.error = chatUtility.errorMessages.messageContentModerated;
                            newMessage.content = chatUtility.hashOutContent(newMessage.content);
                            chatUtility.sanitizeMessage(newMessage);
                            if (newMessage.hasLinkCard) {
                                var linkCardMessages = newMessage.linkCardMessages;
                                linkCardMessages.forEach(function (pieceOfMessage) {
                                    if (!pieceOfMessage.isCard) {
                                        pieceOfMessage.content = chatUtility.hashOutContent(pieceOfMessage.content);
                                    }
                                });
                            }
                        } else {
                            newMessage.canResend = true;
                        }
                    } else {
                        var messageFromServer = data.content;
                        newMessage.sendMessageHasError = false;
                        if (angular.isUndefined($scope.dialogData.messagesDict)) {
                            $scope.dialogData.messagesDict = {};
                        }

                        newMessage.id = data.messageId;
                        newMessage.sent = data.sent;
                        newMessage.messageType = data.messageType;
                        messageService.buildTimeStamp(newMessage, $scope.dialogData);
                        messageService.buildDisplayMessage(newMessage);
                        newMessage.resetClusterMessage = true;
                        chatUtility.sanitizeMessage(data);
                        newMessage.content = data.content;
                        newMessage.pieces = data.pieces;
                        newMessage.filteredForReceivers = data.filteredForReceivers;
                        newMessage.messageType = data.messageType;
                        newMessage.senderType = messageHelper.senderTypes.user;
                        messageService.setClusterMaster($scope.dialogData, newMessage);
                        if (newMessage.hasLinkCard && newMessage.rawContent !== messageFromServer) {
                            if (!data.hasLinkCard) {
                                newMessage.hasLinkCard = false;
                            } else {
                                gameService.fetchDataForLinkCard([data], $scope.chatLibrary);
                                newMessage.linkCardMessages = data.linkCardMessages;
                            }
                        }
                        $scope.dialogData.messagesDict[data.messageId] = newMessage;
                    }
                }
            },
            function (errorData) {
                $log.debug(" ------ sendMessage error -------");
                newMessage.sendingMessage = false;
                newMessage.sendMessageHasError = true;
                newMessage.canResend = true;
                if (errorData === chatUtility.sendMessageErrorCode.textTooLong) {
                    newMessage.error = chatUtility.errorMessages.textTooLong;
                }
            });
    }

    $scope.toggleDetails = function () {
        $scope.dialogLayout.details.isEnabled = !$scope.dialogLayout.details.isEnabled;
        $scope.saveIntoDialogsLayout();
    }

    $scope.toggleConversationEditor = function () {
        $scope.dialogLayout.details.isConversationTitleEditorEnabled = !$scope.dialogLayout.details.isConversationTitleEditorEnabled;
        $scope.dialogLayout.focusMeEnabled = $scope.dialogLayout.details.isConversationTitleEditorEnabled;
        $scope.saveIntoDialogsLayout();
    }

    $scope.toggleAddFriends = function () {
        $scope.dialogLayout.details.isAddFriendsEnabled = !$scope.dialogLayout.details.isAddFriendsEnabled;
        if ($scope.dialogLayout.details.isAddFriendsEnabled) {
            $scope.addFriends();
        } else {
            $scope.dialogData.addMoreFriends = false;
        }
        $scope.getLimitLinkNameForMemberList();
        $scope.saveIntoDialogsLayout();
    }

    $scope.getLimitLinkNameForMemberList = function (numberOfRemove) {
        var numberOfMemebers = $scope.dialogData.userIds.length;
        if ($scope.dialogData.selectedUserIds) {
            numberOfMemebers += $scope.dialogData.selectedUserIds.length;
        }

        if (numberOfRemove) {
            numberOfMemebers = numberOfMemebers - numberOfRemove;
        }
        $scope.dialogLayout.memberDisplay.linkName = $scope.dialogLayout.memberDisplay.isAll ?
            $scope.dialogLayout.memberDisplay.seeLessLink
            : $scope.dialogLayout.memberDisplay.seeMoreLink + " (" + (numberOfMemebers - $scope.dialogLayout.memberDisplay.defaultLimit) + ")";

    }

    $scope.toggleMemberList = function () {
        $scope.dialogLayout.memberDisplay.isAll = !$scope.dialogLayout.memberDisplay.isAll;

        $scope.dialogLayout.memberDisplay.limitNumber = $scope.dialogLayout.memberDisplay.isAll ?
                                                            $scope.dialogData.userIds.length : $scope.dialogLayout.memberDisplay.defaultLimit;
        $scope.getLimitLinkNameForMemberList();
    }

    $scope.toggleFriendsMenu = function (userId, isHidden) {
        if (isHidden && $scope.dialogLayout.details.friendIdForMenuOn === userId) {
            $scope.dialogLayout.details.friendMenuAction = {};
            $scope.dialogLayout.details.friendIdForMenuOn = null;
        } else if (userId && !isHidden){
            $scope.dialogLayout.details.friendMenuAction[userId] = !$scope.dialogLayout.details.friendMenuAction[userId];
            $scope.dialogLayout.details.friendIdForMenuOn = userId;
        }
    }

    $scope.updatePopoverParams = function () {
        const { id, playTogetherIds } = $scope.dialogData;
        const { dialogSelectorPrefix,
            popoverTriggerSelectorPrefix,
            dialogTriggerClassPrefix } = $scope.dialogLayout.togglePopoverParams;
        const { togglePopoverParams } = $scope.dialogLayout;
        const togglePopoverParamsUpdate = {
            dialogSelect: dialogSelectorPrefix + id,
            triggerSelector: popoverTriggerSelectorPrefix + id,
            dialogTriggerClassSelector: dialogTriggerClassPrefix + id,
            isOpen: playTogetherIds ? playTogetherIds.length > 0 : false,
            isFirstTimeOpen: true
        }
        Object.assign(togglePopoverParams, togglePopoverParamsUpdate);
    }

    //// ----------------------------------- PUBLIC ---------------------------------
    $scope.dialogParams = Object.assign({}, chatUtility.dialogParams);
    $scope.userPresenceTypes = chatUtility.userPresenceTypes;
    $scope.dialogData.messageForSend = "";
    $scope.dialogLayout.scrollbarElm = chatUtility.getScrollBarSelector($scope.dialogData, chatUtility.scrollBarType.MESSAGE);
    $scope.dialogLayout.listenToScrollInitialized = false;
    $scope.friendsScrollbarElm = chatUtility.getScrollBarSelector($scope.dialogData, chatUtility.scrollBarType.FRIENDSELECTION);
    $scope.updatePopoverParams();
    $scope.updateDialog = function () {
        $log.debug("---- updateDialog callback ---- Scrollbars updated");
        if (!$scope.dialogLayout.IsdialogContainerVisible) {
            var scrollbarObject = angular.element($scope.dialogLayout.scrollbarElm);
            scrollbarObject.find(".mCustomScrollBox").addClass("dialog-visible");
            $scope.dialogLayout.IsdialogContainerVisible = true;
        }
        return false;
    }

    $scope.buildNewMessage = function (newMessage) {
        return {
            read: true,
            content: newMessage,
            rawContent: newMessage,
            senderTargetId: $scope.chatLibrary.userId,
            sendingMessage: true,
            sendMessageHasError: false,
            startSendingTime: new Date().getTime(),
            messageType: "PlainText",
            senderType: "User"
        }
    }
    $scope.sendMessage = function () {
        if ($scope.dialogData.messageForSend.length > 0) {
            var newMessageObj = $scope.buildNewMessage($scope.dialogData.messageForSend);
            chatUtility.sanitizeMessage(newMessageObj);
            gameService.fetchDataForLinkCard([newMessageObj], $scope.chatLibrary);
            $scope.dialogData.messageForSend = "";
            if (angular.isUndefined($scope.dialogData.chatMessages)) {
                $scope.dialogData.chatMessages = [];
            }
            messageService.setClusterMaster($scope.dialogData, newMessageObj);
            $scope.dialogData.displayMessage = newMessageObj;

            sendMessage(newMessageObj);
        }
    }

    $scope.resendMessage = function (resendMessageObj) {
        sendMessage(resendMessageObj);
    }

    $scope.keyPressEnter = function () {
        $scope.sendMessage();
        if ($scope.dialogLayout.typing.isTypingAsSender) {
            $scope.dialogLayout.typing.lastTimeTypingAsSender = null;
            $scope.dialogLayout.typing.isTypingAsSender = false;
        }
    }
    
                        
    $scope.typing = function ($event, isTyping, currentDate) {
        if (isTyping) {
            if ($event.which !== keyCode.enter) {
                var now = currentDate || new Date().getTime();
                var typingStatus = $scope.dialogLayout.typing;

                if (!typingStatus.lastTimeTypingAsSender
                    || (now - typingStatus.lastTimeTypingAsSender > $scope.chatLibrary.typingInChatAsSenderThrottleMs)) {
                    typingStatus.lastTimeTypingAsSender = now;
                    typingStatus.isTypingAsSender = true;
                    chatService.updateUserTypingStatus($scope.dialogData.id, true);
                }
            }

            $scope.toggleDialogFocusStatus(true);
        }
    }

    $scope.abuseReport = function (userId, isConfirmed) {
        $scope.dialogLayout.isConfirmationOn = true;
        // remember userId for the confirmation
        if (userId) {
            $scope.dialogLayout.userIdForAbuseReport = userId; 
        }
        if (isConfirmed && $scope.dialogLayout.userIdForAbuseReport) {
            var relativeUrl = $filter("formatString")(chatUtility.chatLayout.abuseReportUrl,
                {
                    'userId': $scope.dialogLayout.userIdForAbuseReport,
                    'location': escape(window.location),
                    'conversationId': $scope.dialogData.id
                });
            var url = Endpoints 
                ? Endpoints.getAbsoluteUrl(relativeUrl)
                : relativeUrl ;

            if (AbuseReportDispatcher) {
                AbuseReportDispatcher.triggerUrlAction(url);
            }
            else {
                window.location.href = url;
            }

            $scope.dialogLayout.userIdForAbuseReport = null;
            $scope.dialogLayout.isConfirmationOn = false;
        }
        $scope.saveIntoDialogsLayout();
    }

    $scope.leaveGroupChat = function (isConfirmed) {
        if (isConfirmed) {
            $scope.chatLibrary.conversationsDict[$scope.dialogData.id].remove = true;
            $scope.removeFromConversation($scope.dialogData.id, $scope.dialogData.layoutId);
            $scope.resetConfirmDialog();
        } else {
            $scope.dialogLayout.confirmDialog.isOpen = true;
            var leaveChatGroupData = dialogAttributes.negativeAction.leaveChatGroup;
            $scope.dialogLayout.confirmDialog.title = leaveChatGroupData.title;
            $scope.dialogLayout.confirmDialog.headerTitle = leaveChatGroupData.headerTitle;
            $scope.dialogLayout.confirmDialog.btnName = leaveChatGroupData.btnName;
            $scope.dialogLayout.confirmDialog.cancelBtnName = leaveChatGroupData.cancelBtnName;
            $scope.dialogLayout.confirmDialog.type = leaveChatGroupData.type;
        }
    }

    $scope.addFriends = function() {
        $scope.dialogData.addMoreFriends = true;
        if ($scope.chatLibrary.friendIds.length > 0) {
            $scope.updateFriends();
        }
        $scope.dialogData.scrollBarType = chatUtility.scrollBarType.FRIENDSELECTION;

    }

    $scope.viewParticipants = function () {
        $scope.dialogLayout.lookUpMembers = !$scope.dialogLayout.lookUpMembers;
    }

    $scope.toggleGroupNameEditor = function () {
        $scope.dialogLayout.renameEditor.isEnabled = !$scope.dialogLayout.renameEditor.isEnabled;
        $scope.dialogLayout.renameEditor.hasFocus = !$scope.dialogLayout.renameEditor.hasFocus;

        $scope.updateDialogStyle();
        $scope.dialogLayout.focusMeEnabled = !$scope.dialogLayout.renameEditor.isEnabled;
    }

    $scope.renameTitle = function () {
        var legacyTitle = $scope.dialogData.title;
        chatService.renameGroupConversation($scope.dialogData.id, $scope.dialogData.name)
            .then(function (data) {
                if (data) {
                    switch (data.resultType) {
                        case chatUtility.resultType.MODERATED:
                            messageService.buildSystemMessage(chatUtility.notificationType.conversationTitleModerated,
                                $scope.dialogData, true);
                            chatUtility.updateConversationTitle($scope.dialogData, legacyTitle);
                            break;
                        case chatUtility.resultType.SUCCESS:
                            chatUtility.updateConversationTitle($scope.dialogData, data.conversationTitle);
                            break;
                    }
                    $scope.toggleConversationEditor();
                }
            });
    }

    $scope.removeMember = function (id, isConfirmed) {
        if (isConfirmed) {
            $scope.resetConfirmDialog();
            $scope.getLimitLinkNameForMemberList(1);
            chatService.removeFromConversation(id, $scope.dialogData.id)
                        .then(
                            function () {
                                $scope.isOverLoaded();
                            }
                        );
        } else {
            $scope.dialogLayout.confirmDialog.isOpen = true;
            var removeUserData = dialogAttributes.negativeAction.removeUser;
            $scope.dialogLayout.confirmDialog.title = removeUserData.title;
            $scope.dialogLayout.confirmDialog.headerTitle = removeUserData.headerTitle;
            $scope.dialogLayout.confirmDialog.btnName = removeUserData.btnName;
            $scope.dialogLayout.confirmDialog.cancelBtnName = removeUserData.cancelBtnName;
            $scope.dialogLayout.confirmDialog.type = removeUserData.type;
            $scope.dialogLayout.confirmDialog.params = { userId : id};
        }
    }

    $scope.resetConfirmDialog = function () {
        const resetParams = {
            isOpen: false,
            title: "",
            btnName: "",
            type: "",
            params: {}
        }
        Object.assign($scope.dialogLayout.confirmDialog, resetParams);
    }

    $scope.confirmCallBack = function () {
        const { confirmDialog } = $scope.dialogLayout;
        switch (confirmDialog.type) {
            case dialogAttributes.negativeAction.removeUser.type:
                $scope.removeMember(confirmDialog.params.userId, true);
                break;
            case dialogAttributes.negativeAction.leaveChatGroup.type:
                $scope.leaveGroupChat(true);
                break;
        }
    }

    $scope.updateDialogHeader = function (isHovered) {
        if ($scope.dialogLayout.collapsed) {
            $scope.dialogLayout.hoverOnCollapsed = isHovered;
        }
    }

    $scope.isDialogMainContainerHidden = function () {
        return $scope.dialogData.addMoreFriends || $scope.dialogLayout.details.isEnabled || $scope.dialogLayout.voiceChatLayout.isLobbyEnabled;
    }

    //// ----------------------------------- CODE TO RUN --------------------------------
    chatService.getMessages($scope.dialogData.id, null, $scope.dialogParams.pageSizeOfGetMessages)
                    .then(
                        function (data) {
                            if (data && data.length > 0) {
                                $scope.dialogData.chatMessages = [];
                                $scope.dialogData.messagesDict = {};
                                messageService.processMessages($scope.chatLibrary, $scope.dialogData, data, $scope.chatLibrary.friendsDict);
                                gameService.fetchDataForLinkCard(data, $scope.chatLibrary);
                                $scope.dialogData.scrollBarType = chatUtility.scrollBarType.MESSAGE;
                            } else {
                                $scope.dialogData.scrollBarType = chatUtility.scrollBarType.MESSAGE;
                                $scope.updateDialog();
                            }
                        });
    
    $scope.$on('elastic:resize',
        function (event, element, oldHeight, newHeight) {
            $log.debug("---- oldHeight -----" + oldHeight + "---- newHeight -----" + newHeight);
            if (oldHeight !== newHeight) {
                event.preventDefault();
                event.stopPropagation();
                chatUtility.setResizeInputLayout($scope.chatLibrary, newHeight, $scope.dialogData, $scope.dialogLayout);
            }
    });

    $scope.init = function () {
        $scope.getLimitLinkNameForMemberList();
    }

    $scope.init();
};

chatModule.controller("dialogController", dialogController);

export default dialogController;